import { render, staticRenderFns } from "./realized-over-time-base.vue?vue&type=template&id=027f7df4&scoped=true&"
import script from "./realized-over-time-base.vue?vue&type=script&lang=ts&"
export * from "./realized-over-time-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f7df4",
  null
  
)

export default component.exports